import { DateTime } from 'luxon'
import { Token } from 'models'

export const formatToken = (token: any) => {
  return {
    access_token: token?.accessToken || token?.access_token,
    refresh_token: token?.refreshToken || token?.refresh_token,
    expires_in: token?.expiresIn || token?.expires_in || token?.expires,
    token_created: token?.created || token?.token_created || DateTime.local().setZone('utc').toString()
  } as Token
}